import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useClinic } from '@/stores/ClinicContext';
import { Role } from '@/types/auth';

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated, loading, profile } = useAuth();
  const { isOwner } = useClinic();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen bg-surface flex flex-col items-center justify-center">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Agendador externo: rota restrita ao próprio painel. Tentativas de acessar
  // outras áreas redirecionam para /agendador (defesa em camadas — as regras
  // do Firestore já bloqueiam dados sensíveis, mas evitamos UI quebrada).
  //
  // EXCEÇÃO: o owner da clínica nunca é redirecionado, mesmo que o próprio
  // cargo seja AGENDADOR_EXTERNO (cenário típico: dono testando o painel).
  // Sem isso, ao trocar o próprio cargo para teste, o dono ficava trancado
  // sem opção de voltar atrás dentro do app.
  if (profile?.role === Role.AGENDADOR_EXTERNO && !isOwner) {
    if (!location.pathname.startsWith('/agendador')) {
      return <Navigate to="/agendador" replace />;
    }
  }

  // Totem: conta dedicada ao auto-atendimento. Fica trancada em /totem*;
  // qualquer outra rota redireciona. Mesma exceção do owner — dono testando
  // não pode ficar preso sem conseguir sair.
  if (profile?.role === Role.TOTEM && !isOwner) {
    if (!location.pathname.startsWith('/totem')) {
      return <Navigate to="/totem" replace />;
    }
  }

  return children;
};
